define((require) => {
    "use strict";

    const ImprovedView  = require("editor/zbone/ImprovedView");
    const Preconditions = require("shared/util/Preconditions");
    const $             = require("jquery");
    const _             = require("underscore");
    const Window        = require("shared/services/Window");
    const Keyboard      = require("services/Keyboard");
    const template      = _.template("<div class=\"input-selection\"><% _.each(choices, function (choice) { %><span class=\"input-choice\"><%- choice.label %></span><% }) %></div>");

    const CLICK_EVENT = "click.input-selection";

    const $body = $("body");

    /**
     * Helps create a set of optional choices for the user when inserting data
     * in an input field. The data inputted are in no way limited to the
     * options provide -- they serve only as a guide for the user to quickly
     * click.
     *
     * Notice that this class listens to clicks on the body element to
     * determine when to close the set of options. If clicks on the body, for
     * some reason, are prevented (usually via stopPropagation), then it's
     * needed to call the `closeDropdown` method manually to close it.
     *
     * @class InputSelection
     * @author Gorm Casper
     */
    return ImprovedView.extend({

        /**
         * The input field that we apply our options/choices to.
         */
        $input: null,

        /**
         * The container of the choices. This will default to the body if none
         * is applied. The choices dropdown will be appended and the end of the
         * container.
         */
        $container: null,

        /**
         * Ordered array of objects with labels and values. Labels will always
         * be strings and are used in the dom.
         *
         * [{label: "18", value: 18}]
         */
        choices: null,

        /**
         * Object used for quickly looking up values based on their label.
         * {label: value}
         */
        lookup: null,

        constructor(options) {
            this.$input = options.$input;
            this.choices = options.choices;
            this.$container = options.$container || $body;

            // Choices can be be given as a long list of choices if the label
            // does not differ from its value. If this is the case, then we
            // need to normalize the data.
            if (!_.isArray(options.choices[0])) {
                this.choices = options.choices.map((choice) => ({
                    label: choice.toString(),
                    value: choice
                }));
            }

            // Make lookup table which is basically an object with labels as
            // keys.
            this.lookup = this.choices.reduce((lookup, choice) => {
                lookup[choice.label] = choice.value;

                return lookup;
            }, {});

            Preconditions.is$element(this.$input);
            Preconditions.is$element(this.$container);
            Preconditions.isArray(this.choices);

            this.$dropdown = $(template({choices: this.choices}));

            _.bindAll(this, "_selectChoice", "_clickCloseHandler", "_showDropdown", "closeDropdown", "_positionDropdown");

            this.$input.on({
                focus: this._showDropdown,
                click: this._showDropdown,
                change: this.closeDropdown
            });

            this.$dropdown.on(CLICK_EVENT, this._selectChoice);

            this.resizeEvents = Window.on("resize", this._positionDropdown); // already bound to this above!
        },

        /**
         * Shows and positions the dropdown. Also sets up listeners to listen
         * for when to close it again.
         *
         * @private
         */
        _showDropdown() {
            this.$container.append(this.$dropdown.show());

            this._positionDropdown();

            $body.on(CLICK_EVENT, this._clickCloseHandler);
            this.listenTo(Keyboard.Down, Keyboard.KeyCode.TAB, this.closeDropdown);
        },

        /**
         * Places the dropdown below the input field and adjusts its width and
         * height.
         *
         * @private
         */
        _positionDropdown() {
            // Quick sanity check. This is to prevent work when the function
            // is called from the resize event.
            if (!this.$input.is(":visible")) {
                return;
            }

            const $inputRect = this.$input.get(0).getBoundingClientRect();

            this.$dropdown.css({
                top: $inputRect.bottom + 1,
                left: $inputRect.left,
                width: $inputRect.width,
                bottom: "auto"
            });

            // If the choices box extends below the window, then we need to
            // push it up so it stops just before the end of the window.
            if (window.innerHeight - this.$dropdown.get(0).getBoundingClientRect().bottom < 2) {
                this.$dropdown.css({bottom: 2});
            }
        },

        /**
         * Handles clicks outside the dropdown.
         *
         * @private
         * @param event
         */
        _clickCloseHandler(event) {
            if (event.target === this.$input.get(0)) {
                return;
            }

            this.closeDropdown();
        },

        /**
         * Closes the dropdown and unsibscribes from events that would
         * otherwise close it.
         */
        closeDropdown() {
            $body.off(CLICK_EVENT, this._clickCloseHandler);
            this.stopListening(Keyboard);
            this.$dropdown.hide();
        },

        _selectChoice(event) {
            const choiceValue = this.lookup[event.target.innerHTML];

            // This shouldn't really be possible unless the user tampers messes
            // with the dom.
            if (choiceValue === undefined) {
                return;
            }

            this.$input.val(choiceValue).trigger("change").blur();
        },

        dispose() {
            // Unsubscribe from listeners.
            this.$input.off();
            this.$dropdown.off();
            this.resizeEvents.off();
            $body.off(CLICK_EVENT, this._clickCloseHandler);

            // Remove the dropdown from the dom.
            this.$dropdown.remove();
        }

    });
});



// WEBPACK FOOTER //
// ./src/editor/services/InputSelection.js